import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'state/hooks';
import { loginSSO } from 'state/userSlice';

export async function handleSSOLogin(dispatch) {
  const response = await dispatch(
    // @ts-ignore
    // ! TS2345: Argument of type 'AsyncThunkAction<any, void, AsyncThunkConfig>' is not assignable to parameter of type 'AnyAction'.
    loginSSO(),
  ).unwrap();

  window.location.href = response.redirected;
}

export function SSOLogin() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isDisabled = import.meta.env.VITE_SSO_DISABLED === 'true';

  useEffect(() => {
    if (isDisabled) navigate('/directlogin');
    else handleSSOLogin(dispatch);
  }, [isDisabled]);

  return null;
}
